// FILE: src/components/Footer/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import DATA from "../../data";
import styles from "./Footer.module.css";

const yearsInBusiness = Math.max(1, new Date().getFullYear() - DATA.company.sinceYear);

export default function Footer() {
  return (
    <footer className={`border-top py-4 bg-surface ${styles.footer}`}>
      <div className="container d-flex flex-wrap justify-content-between align-items-center gap-2">
        <div className="small text-muted-2">
          © {new Date().getFullYear()} {DATA.company.name}. All rights reserved.
        </div>
        <div className="small text-muted-2">{yearsInBusiness}+ years in business</div>
      </div>
      <div className="container d-flex gap-3 mt-2 flex-wrap">
        {DATA.socials.map((s) => (
          <a key={s.label} href={s.href} className="btn btn-link" target="_blank" rel="noreferrer">
            {s.label}
          </a>
        ))}
        <span className="text-muted-2">•</span>
        <Link to="/terms" className="btn btn-link">Terms</Link>
        <span className="text-muted-2">/</span>
        <Link to="/privacy" className="btn btn-link">Privacy</Link>
      </div>
    </footer>
  );
}
